<div
  class="viewer-root"
  [class.viewer-root--embedded]="isComponent"
>
  <div
    #viewport
    class="viewer-viewport"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerUp($event)"
    (wheel)="onWheel($event)"
  >
    @if (imageUrl) {
      <img
        #imageEl
        class="viewer-image"
        [src]="imageUrl"
        [alt]="imageTitle || translations.imageFallbackTitle"
        [style.transform]="transform"
        draggable="false"
      />
    } @else {
      <div class="viewer-empty">{{ translations.noImageAvailable }}</div>
    }
  </div>
</div>
